import { DBCollection } from '@/lib/utils/constants-shared';
import type { Firestore } from 'firebase/firestore';
import { collection, getDocs } from 'firebase/firestore';
import { fetchCollectionFromStorage } from '@/lib/utils/storage-bulk-data';
import type { FirebaseStorage } from 'firebase/storage';
import type { Auth } from 'firebase/auth';

/**
 * Fetch places by passage from Firestore
 */
export async function fetchPlacesByPassageFromDB(_auth: Auth, db: Firestore, storage?: FirebaseStorage): Promise<PlacesByPassage[]> {
    async function fallback() {
        const placesByPassageRef = collection(db, DBCollection.placesByPassage);
        const snapshot = await getDocs(placesByPassageRef);

        return snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
            dateCreated: doc.data().dateCreated?.toDate(),
            dateUpdated: doc.data().dateUpdated?.toDate()
        })) as PlacesByPassage[];
    }

    if (storage) {
        return await fetchCollectionFromStorage<PlacesByPassage>(
            storage,
            `bulk-data/${DBCollection.placesByPassage}.json`,
            fallback
        );
    }

    return await fallback();
}

/**
 * Fetch places for a specific passage from Firestore
 */
export async function fetchPlacesForPassage(passageId: string, _auth: Auth, db: Firestore): Promise<PlacesByPassage | null> {
    const { doc, getDoc } = await import('firebase/firestore');
    const docRef = doc(db, DBCollection.placesByPassage, passageId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
        const data = docSnap.data();
        return {
            id: docSnap.id,
            ...data,
            dateCreated: data.dateCreated?.toDate(),
            dateUpdated: data.dateUpdated?.toDate()
        } as PlacesByPassage;
    }

    return null;
}
